import { Modal } from 'antd';
import styles from './index.module.sass';
import { useState } from 'react';
import managerSvg from '@@/seller-account/images/manager.svg';
import { ButtonMain } from '@/modules/common/components/button';
import { Notifier } from '@@/common/components/notifier';

export const LogisticsNotifier = () => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Modal
        open={visible}
        width={426}
        onCancel={() => setVisible(false)}
        footer={
          <div className={styles.modalFooter}>
            <ButtonMain
              className={styles.footerButton}
              label="понятно"
              onClick={() => setVisible(false)}
            />
          </div>
        }
        closeIcon={null}
      >
        <div className={styles.modalRoot}>
          <img src={managerSvg} width={261} alt="manager" />
          <span>
            Ваша заявка отправлена, ожидайте список транспортных компаний и расценок
            от менеджеров
          </span>
        </div>
      </Modal>
      <Notifier
        bgColor="#66B28A"
        textColor="#FFFFFF"
        heading="Сервис Liliani сможет предоставить список проверенных транспортных компаний и использовать их стоимость для расчетов "
        text="Добавить транспортные компании, подобранные сервисом?"
        buttonLabel="разрешить интеграцию транспортных компаний"
        buttonDisabled
        onClick={
          () => {}
          //() => setVisible(true)
        }
      />
    </>
  );
};
